import React, { useState } from 'react';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';

const ItemsTabs = () => {
const [showAdd, setShowAdd] = useState(false);
const [showEdit, setShowEdit] = useState(false);

const handleShowAdd = (e) => {
e.preventDefault();
setShowAdd(true);
};

const handleShowEdit = (e) => {
e.preventDefault();
setShowEdit(true);
};

const handleCloseAdd = () => setShowAdd(false);
const handleCloseEdit = () => setShowEdit(false);

return (
<>
    <form>
        <div className="row border-bottom-2 pb-3">
            <div className="col-md-12">
                <div className="py-2">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Shipment No.</th>
                                    <th>Shipper</th>
                                    <th>Consignee</th>
                                    <th>House Number</th>
                                    <th>Cargo Type</th>
                                    <th>Packages</th>
                                    <th>Gross Wt.</th>
                                    <th>Volume</th>
                                    <th>Origin</th>
                                    <th>Destination</th>
                                </tr>
                            </thead>
                            <tbody>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
        <div className="py-2">
            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button" onClick={handleShowAdd}>
                    Attached Shipment
                </button>
                <button className="btn btn-primary text-xs" type="button" onClick={handleShowEdit}>
                    New Shipment
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Detach 
                </button>
            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & Close
            </button>
            <button className="btn btn-primary text-xs w-fit" type="submit">
                Save & New
            </button>
            <button className="btn btn-primary text-xs w-fit" type="button">
                Close
            </button>
        </div>
    </form>

    <Offcanvas show={showAdd} onHide={handleCloseAdd} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Item Dtls(New)</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <div className="row">
                <div className="col-md-12">
                    <label className="form-label">Product Code</label>
                    <input type="text" className="form-control form-control-sm" placeholder="" />
                </div>
                <div className="col-md-12">
                    <label className="form-label">Product Name</label>
                    <input type="text" className="form-control form-control-sm" placeholder="" />
                </div>
           

                <div className="col-md-12">
                    <label className="form-label">Goods Line</label>
                    <Select className="custom-selector w-100" name="" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Quantity</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="NOS" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Rate</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="INR" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Gross Wt.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="KGs" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Amount</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="INR" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Country of Origin </label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">HS Code</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-12">
                    <label className="form-label">Manufacturer</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control form-control-sm mt-1" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Invoice No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Date</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="date" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Submit
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseAdd}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>

    <Offcanvas show={showEdit} onHide={handleCloseEdit} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Item Dtls(Edit)</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <div className="row">
                <div className="col-md-12">
                    <label className="form-label">Product Code</label>
                    <input type="text" className="form-control form-control-sm" placeholder="" />
                </div>
                <div className="col-md-12">
                    <label className="form-label">Product Name</label>
                    <input type="text" className="form-control form-control-sm" placeholder="" />
                </div>
             

                <div className="col-md-12">
                    <label className="form-label">Goods Line</label>
                    <Select className="custom-selector w-100" name="" />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Quantity</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="NOS" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Rate</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="INR" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Gross Wt.</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="KGs" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Amount</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="number" className="form-control form-control-sm" placeholder="0.00" />
                        <Select className="custom-selector w-100" name="" placeholder="INR" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Country of Origin </label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">HS Code</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-12">
                    <label className="form-label">Manufacturer</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                    <textarea className="form-control form-control-sm mt-1" rows="4"></textarea>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Invoice No.</label>
                    <div className="d-flex gap-2 flex-row">
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-6">
                    <label className="form-label">Date</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="date" className="form-control form-control-sm custom-selector w-100" />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Update
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseEdit}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>
</>
);
};

export default ItemsTabs;